<template>
	<div class="input-select-multi p-mb-6">
		<!--<div style="display: flex;">-->
		<div>
			<p>
				<!--<b>{{ question }}</b>-->
				<b v-if="questionMark">
					<QuestionComments :questionMark="questionMark" :question="question" />
				</b>
				<b v-else> {{ question }} </b>
			</p>
			<HelpTooltip v-if="bookmark != undefined" :helpbookmark="bookmark" />
		</div>
		<!-- Listen to on change event instead of v-on:input to achieve same result as v-model.lazy -->
		<Dropdown
			:value="value"
			@change="$emit('input', $event.value)"
			:options="options"
		/>
	</div>
</template>

<script>
import Dropdown from "primevue/dropdown";
import HelpTooltip from "../components/HelpTooltip";
import QuestionComments from "./QuestionComments.vue";
export default {
	name: "InputSelectDropdown",
	props: {
		question: String,
		options: Array,
		value: String,
		bookmark: String,

		questionMark: String
	},
	components: {
		Dropdown,
		HelpTooltip,
		QuestionComments
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>
